import React, { useEffect, useState } from 'react'
import TopTitleBar from '../TopTitleBar'
import { useSelector } from "react-redux";
import Loader from '../../../../components/Loader'
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper'
import useRefreshToken from '../../../../Hooks/usegenerateToken';
import { BASE_URL, USER_TOKEN } from '../../../../Utils/constant';

export default function VerifierRequests() {
  useRefreshToken(BASE_URL + USER_TOKEN)
  const [search, setSearch] = useState('')
  const User = useSelector(state => state.User)
  const [list, setList] = useState([])
  const [apiData, setApiData] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)

  useEffect(() => {
    let apiData = [{
      holderId: "1",
      date: "02/07/2024",
      document: "Pan Card",
      consent: true
    },
    {
      holderId: "2",
      date: "15/07/2024",
      document: "Relieving Letter",
      consent: false
    }]
    setApiData(apiData)
    setList(apiData)
  }, [currentPage])

  // async function getVerificationList() {
  //   setLoading(true)
  //   await Delay()
  //   API.get(GET_VERIFIER_SESSIONS + User.id, {
  //     params: {
  //       page_number: currentPage
  //     }
  //   })
  //     .then(res => {
  //       setLoading(false)
  //       if (res.data.status === 200) {
  //         let { data } = res.data
  //         setList(data.items)
  //         setApiData(data.items)
  //         setCurrentPage(data.current_page)
  //         setTotalPages(data.total_pages)
  //       }
  //     })
  //     .catch(err => {
  //       console.log(err)
  //       setLoading(false)
  //       cogoToast.error(err.response.data.detail)
  //     })
  // }
  function handleSearch(value) {
    if (value.length === 0) setList(apiData)
    else {
      const lowercasedValue = value.toLocaleLowerCase();
      const result = apiData.filter(item => {
        const matchesDocument = item.document.toLocaleLowerCase().includes(lowercasedValue);
        const matchesHolderId = item.holderId.toString().toLocaleLowerCase().includes(lowercasedValue);
        return matchesDocument || matchesHolderId;
      });
      setList(result);
    }
    setSearch(value)
  }
  // const handlePageChange = (nextPage) => {
  //   setCurrentPage(nextPage);
  // }

  return (
    <>
      <TopTitleBar isChild >
        <h2 className="topTitleBarText"> <span className="secondaryButton1">Verifying Requests</span></h2>
      </TopTitleBar>
      <Loader isOpen={loading} />
      <section className="table-header6">
        <div className="inputField2">
          <div className="input1">
            <div className="content1">
              <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
              <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
            </div>
          </div>
        </div>
      </section>
      <div className="credentials-table">
        <SlideUpWrapper>
          <table>
            <tr className="credentials-header bg-lgray">
              <th className="credentials-th flex-grow-2">
                <div className="credentials-table-text">Holder Id</div>
              </th>
              <th className="credentials-th flex-grow-2">
                <div className="credentials-table-text">Requested On</div>
              </th>
              <th className="credentials-th flex-grow-2">
                <div className="credentials-table-text">Document</div>
              </th>
              <th className="credentials-th flex-grow-2">
                <div className="credentials-table-text">Consent Provided</div>
              </th>
            </tr>
            {
              list.map((item, index) =>
                <tr className="credentials-header" key={index} style={loading ? null : { animationDelay: `${index * 0.1}s` }}>
                  <td className="credentials-th flex-grow-2">
                    <div className="credentials-table-text">{item.holderId}</div>
                  </td>
                  <td className="credentials-th flex-grow-2">
                    <div className="credentials-table-text">{item.date}</div>
                  </td>
                  <td className="credentials-th flex-grow-2">
                    <div className="credentials-table-text">{item.document}</div>
                  </td>
                  <td className="credentials-th flex-grow-2">
                    {item.consent ?
                      <div className="credentials-table-text">View</div> :
                      <div className="credentials-table-text">Requested</div>}

                  </td>
                </tr>
              )
            }
          </table>
        </SlideUpWrapper>
      </div >
      {/* <div style={{ margin: "10px" }}>
          <Pagination
            nPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div> */}
    </>
  )
}
